import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from "@mui/material";
import navigationPaths from "../../engine/navigationPaths";
import { useUserAutologin } from 'api/endpoints/postLogonAutlogin';
import {doGetAuthenticatedUserAsync} from '../../features/logon/logonSlice';
import { useDispatch } from 'react-redux';

export const Autologin = () => {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const navigate = useNavigate();
    const token = query.get('token');
    const dispatch = useDispatch();

    const {        
        isLoading: isLoadingData
    } = useUserAutologin(token, {
        onSuccess: (data) => {
            dispatch(doGetAuthenticatedUserAsync()).unwrap().then(()=>{
                navigate(navigationPaths().Home);
            });           
        },
        onError: (error) => {
            console.log(error);
        }
    });

    return ( 
     <div>
        <Typography fontSize={24} sx={{mb:1}}>Trwa autologowanie: {isLoadingData}.</Typography>
    </div>)

}